import { render } from "./NewInstance.vue?vue&type=template&id=e05f7744"
import script from "./NewInstance.vue?vue&type=script&lang=js"
export * from "./NewInstance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__